// 📄 catalogoCasosPruebaService.ts
// Catálogo GLOBAL de escenarios de prueba sugeridos por solución/canal —
// idea #6 de integración de Casos de Prueba (ver casoPruebaService.ts):
// una biblioteca de plantillas que el equipo consultor puede "clonar" a un
// proyecto en vez de escribir el mismo escenario típico de cero cada vez
// (ej. "Creación de orden de compra" para Commerce → Orden de Compra).
// Mismo patrón exacto que catalogoBadisService.ts/catalogoProgramasService.ts:
// CRUD completo solo desde el panel Admin, lectura abierta a cualquier
// consultor autenticado (ver firestore.rules, colección `catalogoCasosPrueba`).
import {
  doc,
  collection,
  getDocs,
  setDoc,
  deleteDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from '../firebase';
import { CampoPrueba } from './casoPruebaService.ts';

export interface EscenarioPruebaData {
  nombre: string;
  solucion: string;
  // Igual criterio que CasoPruebaFormData: no todas las soluciones tienen
  // un catálogo de canales definido, quedan sin canal específico.
  canalId?: string;
  canalNombre?: string;
  // Campos SUGERIDOS — acá `valor` es un ejemplo/placeholder (ej. "1234"),
  // no un dato real de ningún proyecto puntual; se copia tal cual al clonar
  // y el usuario lo ajusta después en su proyecto.
  campos: CampoPrueba[];
  detalles: string;
}

export interface EscenarioPrueba extends EscenarioPruebaData {
  id: string;
  createdAt?: any;
  updatedAt?: any;
}

const CATALOGO_COLLECTION = "catalogoCasosPrueba";

export const getEscenariosPrueba = async (): Promise<EscenarioPrueba[]> => {
  const snap = await getDocs(collection(db, CATALOGO_COLLECTION));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() as Omit<EscenarioPrueba, 'id'>) }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre));
};

export const saveEscenarioPrueba = async (escenarioId: string, data: EscenarioPruebaData, esNuevo: boolean): Promise<void> => {
  if (!data.nombre.trim()) throw new Error("El nombre del escenario es obligatorio.");

  const payload: Record<string, any> = {
    nombre: data.nombre.trim(),
    solucion: data.solucion,
    campos: data.campos.filter((c) => c.nombre.trim()),
    detalles: data.detalles.trim(),
    updatedAt: serverTimestamp()
  };
  if (data.canalId) {
    payload.canalId = data.canalId;
    payload.canalNombre = data.canalNombre || '';
  }
  if (esNuevo) payload.createdAt = serverTimestamp();

  await setDoc(doc(db, CATALOGO_COLLECTION, escenarioId), payload, { merge: true });
};

export const deleteEscenarioPrueba = async (escenarioId: string): Promise<void> => {
  await deleteDoc(doc(db, CATALOGO_COLLECTION, escenarioId));
};
